<div class="d-flex align-items-center p-2 border-top">
    <img
        src="https://e7.pngegg.com/pngimages/178/595/png-clipart-user-profile-computer-icons-login-user-avatars-monochrome-black.png"
        alt="Avatar Marco Martini"
        class="user-avatar"
    />
    <div class="flex-grow-1">
        @if (authService.user$ | async; as user) {
            <span class="text-break d-block fw-normal">{{ user.firstName }} {{ user.lastName }}</span>
            <small class="text-break text-light">{{ user.email }}</small>
        }
    </div>
    <button class="btn" (click)="authService.logout()">
        <i class="fa fa-right-from-bracket"></i>
    </button>
</div>
